import React, { useEffect, useState } from "react";
import MainHeading from "../../components/comman/MainHeading";
import PlusIcon from "../../components/Icons/PlusIcon";
import { Nav, NavItem, NavLink, TabContent, TabPane, Fade, Spinner } from "reactstrap";
import CreateTaskModal from "./CreateTaskModal";
import TaskDetailModal from "./TaskDetailModal";
import EditIcon from "../../components/Icons/EditIcon";
import DeleteIcon from "../../components/Icons/DeleteIcon";
import { MainFilterHandler } from "../../components/comman/MainFilterHandler";
import { toast } from "react-toastify";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { callApi } from "../../ApiHelper/ApiHelper";
import PaginationComponent from "../../components/comman/PaginationComponent";
import moment from "moment";
import { handlePriorityStatus, handleTaskStatus, getInitials } from "../../utility/CommonFunctions";
import NoRecordIcon from "../../components/Icons/NoRecordIcon";
import ConfirmModal from "../../components/comman/ConfirmModal";
import { useSelector } from "react-redux";
import CreateSubTaskModal from "./CreateSubTaskModal";

function OfficeTaskManagement({ localDateFilter }) {
    const userDetails = useSelector((state) => state.root.userDetails);
    const filterDetails = useSelector((state) => state.root.filtersStates);
    const [activeTab, setActiveTab] = useState(userDetails?.type == 2 ? "allTasks" : "siteTask");
    const [filterTab, setFilterTab] = useState("All");
    const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
    const [isAddEditSubTaskModalOpen, setIsAddEditSubTaskModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [refreshSubTask, setRefreshSubTask] = useState(0);
    const [modal, setModal] = useState(false);
    const [isLoadingDelete, setIsLoadingDelete] = useState(false);
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);
    const [isCreateSubTask, setIsCreateSubTask] = useState(false);
    const toggleModal = () => {
        setModal(!modal);
    };
    const [selectedId, setSelectedId] = useState("");


    const toggleAddEditModal = () => setIsAddEditModalOpen(!isAddEditModalOpen);
    const toggleDetailModal = () => setIsDetailModalOpen(!isDetailModalOpen);
    const toggleAddEditSubTaskModal = () => setIsAddEditSubTaskModalOpen(!isAddEditSubTaskModalOpen);

    const [pageStates, setPageStates] = useState({
        currentPage: 1,
        pageSize: 10,
        count: 0,
        totalPages: 0,
        tasksList: [],
        status: '',
        searchQuery: '',
        year: filterDetails?.year || '',
        siteId: filterDetails?.siteId || '',
        sortByDate: localDateFilter || [],
        isLoadingTasks: false,
        statusCounts: {
            cancelled: 0,
            done: 0,
            inProgress: 0,
            overdue: 0,
            todo: 0
        },
    });

    useEffect(() => {
        setPageStates((prev) => ({
            ...prev,
            year: filterDetails?.year,
            siteId: filterDetails?.siteId,
            sortByDate: localDateFilter,
            currentPage: 1,
        }));
    }, [filterDetails?.year, filterDetails?.siteId, localDateFilter]);

    useEffect(() => {
        getTaskList();
    }, [pageStates?.currentPage, pageStates?.pageSize, pageStates?.status, pageStates?.year, pageStates?.sortByDate, pageStates?.siteId, activeTab]);

    const getTaskList = () => {
        let options = {
            method: "GET",
        };

        const Url =
            apiUrl.get_tasks + "?" + MainFilterHandler(pageStates) + (activeTab == "allTasks" ? "" : "&tab=" + activeTab);
        setPageStates((pre) => ({
            ...pre,
            isLoadingTasks: !pre.isLoadingTasks,
        }));
        callApi(Url, options).then((res) => {
            setPageStates((pre) => ({
                ...pre,
                isLoadingTasks: !pre.isLoadingTasks,
            }));
            if (res?.status === true) {

                setPageStates((pre) => ({
                    ...pre,
                    tasksList: res?.data?.tasks,
                    count: res?.data?.pageInfo?.total,
                    totalPages: res?.data?.pageInfo?.totalPages,
                    statusCounts: {
                        cancelled: res?.data?.statusCounts?.cancelled,
                        done: res?.data?.statusCounts?.done,
                        inProgress: res?.data?.statusCounts?.inProgress,
                        overdue: res?.data?.statusCounts?.overdue,
                        todo: res?.data?.statusCounts?.todo
                    },
                }));

            }
            else {
                toast.error(res?.message || "Something went wrong");
            }
        });
    };

    const PageChangeHandler = (PageNo) => {
        if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
            setPageStates((prev) => ({
                ...prev,
                currentPage: PageNo,
            }));
        }
    };

    const handleChangePageSize = (value) => {
        setPageStates((prev) => ({
            ...prev,
            pageSize: value,
            currentPage: 1,
        }));
    };

    const HandleDeleteTask = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl.delete_task + `?taskId=${selectedId}`;
        setIsLoadingDelete(true);
        callApi(API, options).then((response) => {
            setIsLoadingDelete(false);
            if (response?.status === true) {
                toast.success(response?.message);
                toggleModal();
                getTaskList();
            } else {
                toast.error(response?.message);
                toggleModal();
            }
        });
    };

    const ActionHandler = (task) => {
        setSelectedId(task?.id);
        toggleModal();
    };

    const onChangeStatus = (taskId, status) => {
        const submitData = {
            "taskId": taskId,
            "status": status,
        }
        const options = {
            method: "PUT",
            data: submitData,
        };
        const API = apiUrl.update_task;
        setIsLoadingStatus(true);
        callApi(API, options).then((response) => {
            setIsLoadingStatus(false);
            if (response?.status === true) {
                toast.success(response.message);
                setPageStates((prev) => ({
                    ...prev,
                    tasksList: prev?.tasksList?.map((task) => task.id === taskId ? { ...task, status: status } : task),
                }));
            } else {
                toast.error(response.message);
            }
        });

    };

    const getPriorityColor = (priority) => {
        switch (priority?.toLowerCase()) {
            case "low": return "#10B981";
            case "medium": return "#F59E0B";
            case "high": return "#EF4444";
            default: return "#9CA3AF";
        }
    };

    const isTaskOverdue = (task) => {
        return task?.status !== "Cancelled" && (
            (task?.status === "Done" && moment(task?.completedDate).isAfter(task?.dueDate, 'day')) ||
            (task?.status !== "Done" && moment(task?.dueDate).isBefore(moment(), 'day'))
        );
    };

    const renderAvatar = (user, bgColor = "#E28743", textColor = "#FFFFFF", size = "24px", fontSize = "10px") => {
        if (!user) return null;
        const initials = getInitials(user.name);
        return (
            <div className="rounded-circle d-flex align-items-center justify-content-center shadow-sm text-uppercase flex-shrink-0"
                style={{ width: size, height: size, backgroundColor: bgColor, color: textColor, fontSize: fontSize, fontWeight: "bold" }}
                title={user.name}>
                {initials}
            </div>
        );
    };

    const summaryData = [
        { title: "TO DO", count: pageStates?.statusCounts?.todo || 0, colorClass: "text-secondary", numColor: "text-secondary" },
        { title: "IN PROGRESS", count: pageStates?.statusCounts?.inProgress || 0, colorClass: "text-warning", numColor: "text-warning" },
        { title: "DONE", count: pageStates?.statusCounts?.done || 0, colorClass: "text-success", numColor: "text-success" },
        { title: "OVERDUE", count: pageStates?.statusCounts?.overdue || 0, colorClass: "text-danger", numColor: "text-danger" },
        { title: "CANCELLED", count: pageStates?.statusCounts?.cancelled || 0, colorClass: "text-danger", numColor: "text-danger" },
    ];

    return (
        <>
            <MainHeading
                // title="Tasks"
                buttonText="Create Task"
                buttonIcon={<PlusIcon />}
                clickHandler={userDetails?.type != 2 ? () => {
                    setSelectedTask(null);
                    toggleAddEditModal()
                } : null}
            />

            {/* Summary Cards */}
            <div className="row g-4 mb-4">
                {summaryData.map((item, idx) => (
                    <div className="col-12 col-sm-6 col-lg-2" key={idx}>
                        <div className="card border-0 shadow-md rounded-4 h-100 px-3 py-2">
                            <div className={`fw-bold mb-1 ${item.colorClass}`} style={{ letterSpacing: "1px", fontSize: "11px" }}>{item.title}</div>
                            <h5 className={`mb-0 fw-bold ${item.numColor}`} style={{ fontSize: "1.2rem" }}>{item.count}</h5>
                        </div>
                    </div>
                ))}
            </div>

            {/* Tabs Row */}
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-3">
                {/* Left Tabs */}
                <Nav tabs className="nav nav-tabs border-0 mb-0">
                    {userDetails?.type != 2 &&
                        <> <NavItem className="nav-item">
                            <NavLink
                                className={
                                    activeTab === 'siteTask'
                                        ? "btn btn-outline-primary px-5 rounded-start-5 rounded-end-0 border-end-0 border-start-1 active"
                                        : "btn btn-outline-primary px-5 rounded-start-5 rounded-end-0 border-end-0 border-start-1"
                                }
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setActiveTab('siteTask')
                                    setPageStates((prev) => ({
                                        ...prev,
                                        currentPage: 1,
                                    }));
                                }}
                            >
                                Tasks
                            </NavLink>
                        </NavItem>
                            <NavItem className="nav-item">
                                <NavLink
                                    className={
                                        activeTab === 'myTask'
                                            ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-1 active"
                                            : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-1"
                                    }
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setActiveTab('myTask')
                                        setPageStates((prev) => ({
                                            ...prev,
                                            currentPage: 1,
                                        }));
                                    }}
                                >
                                    My Tasks
                                </NavLink>
                            </NavItem>
                            <NavItem className="nav-item">
                                <NavLink
                                    className={
                                        activeTab === 'taskCreated'
                                            ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-5 border-end-1 border-start-0 active"
                                            : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-5 border-end-1 border-start-0"
                                    }
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setActiveTab('taskCreated')
                                        setPageStates((prev) => ({
                                            ...prev,
                                            currentPage: 1,
                                        }));
                                    }}
                                >
                                    Tasks I Created
                                </NavLink>
                            </NavItem>

                        </>
                    }
                    {userDetails?.type == 2 &&
                        <NavItem className="nav-item">
                            <NavLink
                                className={
                                    activeTab === 'allTasks'
                                        ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-2 border-end-2 border-start-0 active"
                                        : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-2 border-end-2 border-start-0"
                                }
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setActiveTab('allTasks')
                                    setPageStates((prev) => ({
                                        ...prev,
                                        currentPage: 1,
                                    }));
                                }}
                            >
                                All Tasks
                            </NavLink>
                        </NavItem>}
                </Nav>

                {/* Right Filter Tabs */}
                <div className="d-flex align-items-center bg-white rounded-pill p-1 shadow-sm border" style={{ gap: "4px" }}>
                    {['All', 'To Do', 'In Progress', 'Done', 'Cancelled'].map(tab => (
                        <button
                            key={tab}
                            onClick={() => {
                                setFilterTab(tab)
                                setPageStates((prev) => ({
                                    ...prev,
                                    status: tab === "All" ? "" : tab,
                                    currentPage: 1,
                                }));
                            }}
                            className={`btn rounded-pill px-4 py-2 fw-medium border-0`}
                            style={{
                                backgroundColor: filterTab === tab ? '#048604' : 'transparent',
                                color: filterTab === tab ? 'white' : '#4b5563',
                                transition: "all 0.2s"
                            }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
            </div>

            {/* Task List */}
            <TabContent activeTab={activeTab}>
                <TabPane tabId={'siteTask'}>
                    <Fade in={activeTab === 'siteTask'} timeout={200}>
                        <div className="d-flex flex-column gap-1 mb-5">
                            {pageStates?.isLoadingTasks ? <div style={{ height: "50vh" }} className='d-flex align-items-center justify-content-center'><Spinner /></div> : (
                                pageStates?.tasksList?.length > 0 ?
                                    pageStates?.tasksList?.map(task => (
                                        <div
                                            key={task.id}
                                            className="card shadow-sm rounded-4 overflow-hidden task-card-hover mb-3"
                                            style={{ cursor: 'pointer', border: 'none', transition: 'all 0.3s ease', borderLeft: `4px solid ${getPriorityColor(task?.priority)}` }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.classList.add('shadow'); e.currentTarget.classList.remove('shadow-sm'); }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.classList.add('shadow-sm'); e.currentTarget.classList.remove('shadow'); }}
                                            onClick={() => { setSelectedTask(task); setIsDetailModalOpen(true); }}
                                        >
                                            <div className="card-body px-3 py-2 d-flex flex-column gap-1">
                                                {/* Top row: Title and Status */}
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div className="d-flex flex-column gap-1">
                                                        <span style={{ fontSize: "11px", fontWeight: "600", color: task?.parentTaskId != null ? '#048604' : '#878a99', letterSpacing: "0.3px" }} className="d-flex align-items-center gap-1 text-uppercase">
                                                            {task?.parentTaskId != null ? (
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M3.5 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 1 0V6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-9z" /><path fillRule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L10.707 4l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708 0z" /></svg>
                                                                    Sub Task
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 14.5 0h-13zM1 1.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13z" /><path d="M5.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5z" /></svg>
                                                                    Task
                                                                </>
                                                            )}
                                                        </span>
                                                        <h5 className="fw-semibold text-dark mb-0 pe-3" style={{ letterSpacing: "-0.3px" }}>{task?.title}</h5>
                                                    </div>
                                                    <div className="flex-shrink-0 d-flex flex-column align-items-end gap-2">
                                                        <select
                                                            className={`form-select px-3 py-1 rounded-pill shadow-sm border fw-bold ${task.status === 'To Do' ? 'bg-light text-secondary border-secondary-subtle' :
                                                                task.status === 'In Progress' ? 'bg-primary-subtle text-primary border-primary-subtle' :
                                                                    task.status === 'Done' ? 'bg-success-subtle text-success border-success-subtle' :
                                                                        task.status === 'Cancelled' ? 'bg-danger-subtle text-danger border-danger-subtle' : ''
                                                                }`}
                                                            value={task.status}
                                                            onChange={(e) => onChangeStatus(task.id, e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            disabled
                                                            style={{ width: "auto", minWidth: "130px", fontSize: "10px", cursor: (isLoadingStatus || task.status === "Done" || task.status === "Cancelled") ? "not-allowed" : "pointer" }}>
                                                            <option value="To Do" className="bg-light text-secondary fw-bold">To Do</option>
                                                            <option value="In Progress" className="bg-primary-subtle text-primary fw-bold">In Progress</option>
                                                            <option value="Done" className="bg-success-subtle text-success fw-bold">Done</option>
                                                            <option value="Cancelled" className="bg-danger-subtle text-danger fw-bold">Cancelled</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                {/* Middle row: Priority, Due Date, Assigned */}
                                                <div className="d-flex flex-wrap justify-content-between align-items-center mt-2">
                                                    <div className="d-flex align-items-center gap-3">
                                                        {handlePriorityStatus(task?.priority)}
                                                        <div className={`d-flex align-items-center fw-bold ${isTaskOverdue(task) ? 'text-danger' : 'text-muted'}`} style={{ fontSize: "10px" }}>
                                                            {isTaskOverdue(task) ? (
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.25-11a.75.75 0 0 1 .75.75v3.5l2.25 1.35a.5.5 0 0 1-.52.85l-2.5-1.5A.5.5 0 0 1 8 9.5V5.75A.75.75 0 0 1 8.25 5z" />
                                                                </svg>
                                                            ) : null}
                                                            {moment(task?.dueDate).format("DD MMM YYYY")}
                                                            {isTaskOverdue(task) && <span className="ms-1">· Overdue</span>}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="text-muted" style={{ fontSize: "10px" }}>Accountable Person</span>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <span className='ms-1 text-capitalize fw-semibold text-primary' style={{ fontSize: "10px" }}>{task?.assignedUsers2?.[0]?.name}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bottom row: Description & Actions */}
                                                <div className="d-flex justify-content-between align-items-end mt-1">
                                                    <div className="flex-grow-1 pe-4">
                                                        <p className="mb-0 text-secondary" style={{ fontSize: '12px', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                            {task?.description || "No description provided."}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    : <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error my-5">
                                        <NoRecordIcon />
                                        {"No task found"}
                                    </div>
                            )}
                        </div>

                        <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
                            <div className="d-flex align-items-center gap-2">
                                {pageStates?.count > 0 && !pageStates?.tableLoader && (
                                    <div className="dropdown short">
                                        <button
                                            className="btn dropdown-toggle border"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {pageStates?.pageSize}
                                            <span>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                                                        stroke="#36394A"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    ></path>
                                                </svg>
                                            </span>
                                        </button>
                                        <ul className="dropdown-menu ">
                                            {[10, 20, 30, 40, 50].map((value) => (
                                                <li key={value}>
                                                    <button
                                                        className={`dropdown-item ${pageStates?.pageSize === value && "active"
                                                            }`}
                                                        onClick={() => handleChangePageSize(value)}
                                                    >
                                                        {value}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                <div>
                                    {pageStates?.count > 0 && !pageStates?.tableLoader && (
                                        <p
                                            className="mb-0 text-muted fw-medium text-uppercase"
                                            style={{ fontSize: "10px" }}
                                        >
                                            {`Showing ${pageStates?.currentPage * pageStates?.pageSize -
                                                (pageStates?.pageSize - 1)
                                                } to ${pageStates?.currentPage * pageStates?.pageSize <
                                                    pageStates?.count
                                                    ? pageStates?.currentPage * pageStates?.pageSize
                                                    : pageStates?.count
                                                } of ${pageStates?.count} entries`}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <PaginationComponent
                                currentPage={pageStates?.currentPage}
                                PageChangeHandler={PageChangeHandler}
                                totalPages={pageStates?.totalPages}
                            />
                        </div>
                    </Fade>
                </TabPane>

                <TabPane tabId={'myTask'}>
                    <Fade in={activeTab === 'myTask'} timeout={200}>
                        <div className="d-flex flex-column gap-1 mb-5">
                            {pageStates?.isLoadingTasks ? <div style={{ height: "50vh" }} className='d-flex align-items-center justify-content-center'><Spinner /></div> : (
                                pageStates?.tasksList?.length > 0 ?
                                    pageStates?.tasksList?.map(task => (
                                        <div
                                            key={task.id}
                                            className="card shadow-sm rounded-4 overflow-hidden task-card-hover mb-3"
                                            style={{ cursor: 'pointer', border: 'none', transition: 'all 0.3s ease', borderLeft: `4px solid ${getPriorityColor(task?.priority)}` }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.classList.add('shadow'); e.currentTarget.classList.remove('shadow-sm'); }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.classList.add('shadow-sm'); e.currentTarget.classList.remove('shadow'); }}
                                            onClick={() => { setSelectedTask(task); setIsDetailModalOpen(true); }}
                                        >
                                            <div className="card-body p-4 d-flex flex-column gap-1">
                                                {/* Top row: Title and Status */}
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div className="d-flex flex-column gap-1">
                                                        <span style={{ fontSize: "11px", fontWeight: "600", color: task?.parentTaskId != null ? '#048604' : '#878a99', letterSpacing: "0.3px" }} className="d-flex align-items-center gap-1 text-uppercase">
                                                            {task?.parentTaskId != null ? (
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M3.5 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 1 0V6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-9z" /><path fillRule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L10.707 4l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708 0z" /></svg>
                                                                    Sub Task
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 14.5 0h-13zM1 1.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13z" /><path d="M5.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5z" /></svg>
                                                                    Task
                                                                </>
                                                            )}
                                                        </span>
                                                        <h5 className="fw-semibold text-dark mb-0 pe-3" style={{ letterSpacing: "-0.3px" }}>{task?.title}</h5>
                                                    </div>
                                                    <div className="flex-shrink-0 d-flex flex-column align-items-end gap-2">
                                                        {handleTaskStatus(task?.status)}
                                                    </div>
                                                </div>

                                                {/* Middle row: Priority, Due Date, Created by */}
                                                <div className="d-flex flex-wrap justify-content-between align-items-center mt-2">
                                                    <div className="d-flex align-items-center gap-3">
                                                        {handlePriorityStatus(task?.priority)}
                                                        <div className={`d-flex align-items-center fw-bold ${task.overdue || moment(task.dueDate).isBefore(moment().format("YYYY-MM-DD")) ? 'text-danger' : 'text-muted'}`} style={{ fontSize: "10px" }}>
                                                            {(task.overdue || moment(task.dueDate).isBefore(moment().format("YYYY-MM-DD"))) ? (
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                                                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                                </svg>
                                                            ) : null}
                                                            {moment(task?.dueDate).format("DD MMM YYYY")}
                                                            {(task.overdue || moment(task.dueDate).isBefore(moment().format("YYYY-MM-DD"))) && <span className="ms-1">· Overdue</span>}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-1">
                                                        <span className="text-muted" style={{ fontSize: "11px" }}>Created by</span>
                                                        {renderAvatar(task?.taskCreator, "#048604", "#FFFFFF", "24px", "10px")}
                                                    </div>
                                                </div>

                                                {/* Bottom row: Description & Actions */}
                                                <div className="d-flex justify-content-between align-items-end mt-1">
                                                    <div className="flex-grow-1 pe-4">
                                                        <p className="mb-0 text-secondary" style={{ fontSize: '12px', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                            {task?.description || "No description provided."}
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    : <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error my-5">
                                        <NoRecordIcon />
                                        {"No task found"}
                                    </div>
                            )}
                        </div>

                        <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
                            <div className="d-flex align-items-center gap-2">
                                {pageStates?.count > 0 && !pageStates?.tableLoader && (
                                    <div className="dropdown short">
                                        <button
                                            className="btn dropdown-toggle border"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {pageStates?.pageSize}
                                            <span>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                                                        stroke="#36394A"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    ></path>
                                                </svg>
                                            </span>
                                        </button>
                                        <ul className="dropdown-menu ">
                                            {[10, 20, 30, 40, 50].map((value) => (
                                                <li key={value}>
                                                    <button
                                                        className={`dropdown-item ${pageStates?.pageSize === value && "active"
                                                            }`}
                                                        onClick={() => handleChangePageSize(value)}
                                                    >
                                                        {value}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                <div>
                                    {pageStates?.count > 0 && !pageStates?.tableLoader && (
                                        <p
                                            className="mb-0 text-muted fw-medium text-uppercase"
                                            style={{ fontSize: "10px" }}
                                        >
                                            {`Showing ${pageStates?.currentPage * pageStates?.pageSize -
                                                (pageStates?.pageSize - 1)
                                                } to ${pageStates?.currentPage * pageStates?.pageSize <
                                                    pageStates?.count
                                                    ? pageStates?.currentPage * pageStates?.pageSize
                                                    : pageStates?.count
                                                } of ${pageStates?.count} entries`}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <PaginationComponent
                                currentPage={pageStates?.currentPage}
                                PageChangeHandler={PageChangeHandler}
                                totalPages={pageStates?.totalPages}
                            />
                        </div>
                    </Fade>
                </TabPane>

                <TabPane tabId={'taskCreated'}>
                    <Fade in={activeTab === 'taskCreated'} timeout={200}>
                        <div className="d-flex flex-column gap-1 mb-5">
                            {pageStates?.isLoadingTasks ? <div style={{ height: "50vh" }} className='d-flex align-items-center justify-content-center'><Spinner /></div> : (
                                pageStates?.tasksList?.length > 0 ?
                                    pageStates?.tasksList?.map(task => (
                                        <div
                                            key={task.id}
                                            className="card shadow-sm rounded-4 overflow-hidden task-card-hover mb-3"
                                            style={{ cursor: 'pointer', border: 'none', transition: 'all 0.3s ease', borderLeft: `4px solid ${getPriorityColor(task?.priority)}` }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.classList.add('shadow'); e.currentTarget.classList.remove('shadow-sm'); }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.classList.add('shadow-sm'); e.currentTarget.classList.remove('shadow'); }}
                                            onClick={() => { setSelectedTask(task); setIsDetailModalOpen(true); }}
                                        >
                                            <div className="card-body p-4 d-flex flex-column gap-1">
                                                {/* Top row: Title and Status */}
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div className="d-flex flex-column gap-1">
                                                        <span style={{ fontSize: "11px", fontWeight: "600", color: task?.parentTaskId != null ? '#048604' : '#878a99', letterSpacing: "0.3px" }} className="d-flex align-items-center gap-1 text-uppercase">
                                                            {task?.parentTaskId != null ? (
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M3.5 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 1 0V6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-9z" /><path fillRule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L10.707 4l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708 0z" /></svg>
                                                                    Sub Task
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 14.5 0h-13zM1 1.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13z" /><path d="M5.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5z" /></svg>
                                                                    Task
                                                                </>
                                                            )}
                                                        </span>
                                                        <h5 className="fw-semibold text-dark mb-0 pe-3" style={{ letterSpacing: "-0.3px" }}>{task?.title}</h5>
                                                    </div>
                                                    <div className="flex-shrink-0 d-flex flex-column align-items-end gap-2">
                                                        <select
                                                            className={`form-select px-3 py-1 rounded-pill shadow-sm border fw-bold ${task.status === 'To Do' ? 'bg-light text-secondary border-secondary-subtle' :
                                                                task.status === 'In Progress' ? 'bg-primary-subtle text-primary border-primary-subtle' :
                                                                    task.status === 'Done' ? 'bg-success-subtle text-success border-success-subtle' :
                                                                        task.status === 'Cancelled' ? 'bg-danger-subtle text-danger border-danger-subtle' : ''
                                                                }`}
                                                            value={task.status}
                                                            onChange={(e) => onChangeStatus(task.id, e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            disabled={isLoadingStatus || task.status === "Done" || task.status === "Cancelled"}
                                                            style={{ width: "auto", minWidth: "130px", fontSize: "10px", cursor: (isLoadingStatus || task.status === "Done" || task.status === "Cancelled") ? "not-allowed" : "pointer" }}>
                                                            <option value="To Do" className="bg-light text-secondary fw-bold">To Do</option>
                                                            <option value="In Progress" className="bg-primary-subtle text-primary fw-bold">In Progress</option>
                                                            <option value="Done" className="bg-success-subtle text-success fw-bold">Done</option>
                                                            <option value="Cancelled" className="bg-danger-subtle text-danger fw-bold">Cancelled</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                {/* Middle row: Priority, Due Date, Assigned */}
                                                <div className="d-flex flex-wrap justify-content-between align-items-center mt-2">
                                                    <div className="d-flex align-items-center gap-3">
                                                        {handlePriorityStatus(task?.priority)}
                                                        <div className={`d-flex align-items-center fw-bold ${isTaskOverdue(task) ? 'text-danger' : 'text-muted'}`} style={{ fontSize: "10px" }}>
                                                            {isTaskOverdue(task) ? (
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.25-11a.75.75 0 0 1 .75.75v3.5l2.25 1.35a.5.5 0 0 1-.52.85l-2.5-1.5A.5.5 0 0 1 8 9.5V5.75A.75.75 0 0 1 8.25 5z" />
                                                                </svg>
                                                            ) : null}
                                                            {moment(task?.dueDate).format("DD MMM YYYY")}
                                                            {isTaskOverdue(task) && <span className="ms-1">· Overdue</span>}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="text-muted" style={{ fontSize: "10px" }}>Accountable Person</span>
                                                        <div className="d-flex align-items-center gap-1">
                                                            <span className='ms-1 text-capitalize fw-semibold text-primary' style={{ fontSize: "10px" }}>{task?.assignedUsers2?.[0]?.name}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bottom row: Description & Actions */}
                                                <div className="d-flex justify-content-between align-items-end mt-1">
                                                    <div className="flex-grow-1 pe-4">
                                                        <p className="mb-0 text-secondary" style={{ fontSize: '13px', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                            {task?.description || "No description provided."}
                                                        </p>
                                                    </div>
                                                    <div className="d-flex gap-2 flex-shrink-0">
                                                        {(userDetails?.id === task?.taskCreator?.id && task.status !== "Done" && task.status !== "Cancelled") && (
                                                            <button type='button'
                                                                className='btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center border-0' style={{ width: '25px', height: '25px', transition: 'all 0.2s', backgroundColor: '#f1f5f9', color: '#64748b' }} onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e2e8f0'; e.currentTarget.style.color = '#048604'; }} onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; e.currentTarget.style.color = '#64748b'; }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedTask(task);
                                                                    if (task?.parentTaskId != null) {
                                                                        // setIsCreateSubTask(false);
                                                                        setIsAddEditSubTaskModalOpen(true);
                                                                    } else {
                                                                        // setIsCreateSubTask(false);
                                                                        setIsAddEditModalOpen(true);
                                                                    }
                                                                }}>
                                                                <EditIcon />
                                                            </button>
                                                        )}
                                                        {(userDetails?.id === task?.taskCreator?.id && task.status !== "Done" && task.status !== "Cancelled") && (
                                                            <button
                                                                type='button'
                                                                className='btn btn-light text-danger rounded-circle p-2 d-flex align-items-center justify-content-center border-0' style={{ width: '25px', height: '25px', transition: 'all 0.2s', backgroundColor: '#fee2e2' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fecaca'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fee2e2'}
                                                                onClick={(e) => { e.stopPropagation(); ActionHandler(task); }}>
                                                                <DeleteIcon />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    : <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error my-5">
                                        <NoRecordIcon />
                                        {"No task found"}
                                    </div>
                            )}
                        </div>

                        <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
                            <div className="d-flex align-items-center gap-2">
                                {pageStates?.count > 0 && !pageStates?.tableLoader && (
                                    <div className="dropdown short">
                                        <button
                                            className="btn dropdown-toggle border"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {pageStates?.pageSize}
                                            <span>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                                                        stroke="#36394A"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    ></path>
                                                </svg>
                                            </span>
                                        </button>
                                        <ul className="dropdown-menu ">
                                            {[10, 20, 30, 40, 50].map((value) => (
                                                <li key={value}>
                                                    <button
                                                        className={`dropdown-item ${pageStates?.pageSize === value && "active"
                                                            }`}
                                                        onClick={() => handleChangePageSize(value)}
                                                    >
                                                        {value}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                <div>
                                    {pageStates?.count > 0 && !pageStates?.tableLoader && (
                                        <p
                                            className="mb-0 text-muted fw-medium text-uppercase"
                                            style={{ fontSize: "10px" }}
                                        >
                                            {`Showing ${pageStates?.currentPage * pageStates?.pageSize -
                                                (pageStates?.pageSize - 1)
                                                } to ${pageStates?.currentPage * pageStates?.pageSize <
                                                    pageStates?.count
                                                    ? pageStates?.currentPage * pageStates?.pageSize
                                                    : pageStates?.count
                                                } of ${pageStates?.count} entries`}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <PaginationComponent
                                currentPage={pageStates?.currentPage}
                                PageChangeHandler={PageChangeHandler}
                                totalPages={pageStates?.totalPages}
                            />
                        </div>
                    </Fade>
                </TabPane>

                <TabPane tabId={'allTasks'}>
                    <Fade in={activeTab === 'allTasks'} timeout={200}>
                        <div className="d-flex flex-column gap-3 mb-5">
                            {pageStates?.isLoadingTasks ? <div style={{ height: "50vh" }} className='d-flex align-items-center justify-content-center'><Spinner /></div> : (
                                pageStates?.tasksList?.length > 0 ?
                                    pageStates?.tasksList?.map(task => (
                                        <div
                                            key={task.id}
                                            className="card shadow-sm rounded-4 overflow-hidden task-card-hover mb-3"
                                            style={{ cursor: 'pointer', border: 'none', transition: 'all 0.3s ease', borderLeft: `4px solid ${getPriorityColor(task?.priority)}` }}
                                            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.classList.add('shadow'); e.currentTarget.classList.remove('shadow-sm'); }}
                                            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.classList.add('shadow-sm'); e.currentTarget.classList.remove('shadow'); }}
                                            onClick={() => { setSelectedTask(task); setIsDetailModalOpen(true); }}
                                        >
                                            <div className="card-body p-4 d-flex flex-column gap-3">
                                                {/* Top row: Title and Status */}
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div className="d-flex flex-column gap-1">
                                                        <span style={{ fontSize: "11px", fontWeight: "600", color: task?.parentTaskId != null ? '#048604' : '#878a99', letterSpacing: "0.3px" }} className="d-flex align-items-center gap-1 text-uppercase">
                                                            {task?.parentTaskId != null ? (
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M3.5 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 1 0V6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-9z" /><path fillRule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L10.707 4l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2a.5.5 0 0 1 .708 0z" /></svg>
                                                                    Sub Task
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16"><path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 14.5 0h-13zM1 1.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-13z" /><path d="M5.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zM5.5 12a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5z" /></svg>
                                                                    Task
                                                                </>
                                                            )}
                                                        </span>
                                                        <h4 className="fw-semibold text-dark mb-0 pe-3" style={{ letterSpacing: "-0.3px" }}>{task?.title}</h4>
                                                    </div>
                                                    <div className="flex-shrink-0 d-flex flex-column align-items-end gap-2">
                                                        {handleTaskStatus(task?.status)}
                                                    </div>
                                                </div>

                                                {/* Middle row: Priority, Due Date, Assigned */}
                                                <div className="d-flex flex-wrap justify-content-between align-items-center mt-2">
                                                    <div className="d-flex align-items-center gap-3">
                                                        {handlePriorityStatus(task?.priority)}
                                                        <div className={`d-flex align-items-center fw-bold ${isTaskOverdue(task) ? 'text-danger' : 'text-muted'}`} style={{ fontSize: "13px" }}>
                                                            {isTaskOverdue(task) ? (
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="me-1" viewBox="0 0 16 16">
                                                                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                                                </svg>
                                                            ) : null}
                                                            {moment(task?.dueDate).format("DD MMM YYYY")}
                                                            {isTaskOverdue(task) && <span className="ms-1">· Overdue</span>}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="text-muted" style={{ fontSize: "10px" }}>Assigned to</span>
                                                        <div className="d-flex align-items-center gap-1">
                                                            {task?.assignedUser ? renderAvatar(task?.assignedUser, "#E28743", "#FFFFFF", "24px", "10px") : null}
                                                            {task?.assignedUser2 ? renderAvatar(task?.assignedUser2, "#048604", "#FFFFFF", "24px", "10px") : null}
                                                            {!task?.assignedUser && !task?.assignedUser2 && <span className="fw-bold text-dark" style={{ fontSize: "12px" }}>Unassigned</span>}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bottom row: Description & Actions */}
                                                <div className="d-flex justify-content-between align-items-end mt-1">
                                                    <div className="flex-grow-1 pe-4">
                                                        <p className="mb-0 text-secondary" style={{ fontSize: '15px', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                            {task?.description || "No description provided."}
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    : <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error my-5">
                                        <NoRecordIcon />
                                        {"No task found"}
                                    </div>
                            )}
                        </div>

                        <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
                            <div className="d-flex align-items-center gap-2">
                                {pageStates?.count > 0 && !pageStates?.tableLoader && (
                                    <div className="dropdown short">
                                        <button
                                            className="btn dropdown-toggle border"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {pageStates?.pageSize}
                                            <span>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                                                        stroke="#36394A"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    ></path>
                                                </svg>
                                            </span>
                                        </button>
                                        <ul className="dropdown-menu ">
                                            {[10, 20, 30, 40, 50].map((value) => (
                                                <li key={value}>
                                                    <button
                                                        className={`dropdown-item ${pageStates?.pageSize === value && "active"
                                                            }`}
                                                        onClick={() => handleChangePageSize(value)}
                                                    >
                                                        {value}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                <div>
                                    {pageStates?.count > 0 && !pageStates?.tableLoader && (
                                        <p
                                            className="mb-0 text-muted fw-medium text-uppercase"
                                            style={{ fontSize: "10px" }}
                                        >
                                            {`Showing ${pageStates?.currentPage * pageStates?.pageSize -
                                                (pageStates?.pageSize - 1)
                                                } to ${pageStates?.currentPage * pageStates?.pageSize <
                                                    pageStates?.count
                                                    ? pageStates?.currentPage * pageStates?.pageSize
                                                    : pageStates?.count
                                                } of ${pageStates?.count} entries`}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <PaginationComponent
                                currentPage={pageStates?.currentPage}
                                PageChangeHandler={PageChangeHandler}
                                totalPages={pageStates?.totalPages}
                            />
                        </div>
                    </Fade>
                </TabPane>
            </TabContent>

            <CreateTaskModal
                isOpen={isAddEditModalOpen}
                toggle={toggleAddEditModal}
                selectedTask={selectedTask}
                getTaskList={getTaskList} />

            <CreateSubTaskModal
                isOpen={isAddEditSubTaskModalOpen}
                toggle={toggleAddEditSubTaskModal}
                selectedSubTask={selectedTask}
                getTaskList={getTaskList}
                isCreate={isCreateSubTask}
                setIsCreateSubTask={setIsCreateSubTask}
                refreshSubTask={() => setRefreshSubTask(Date.now())} />

            <TaskDetailModal
                isOpen={isDetailModalOpen}
                toggle={toggleDetailModal}
                selectedTask={selectedTask}
                getTaskList={getTaskList}
                userDetails={userDetails}
                activeTab={activeTab}
                toggleAddEditSubTaskModal={toggleAddEditSubTaskModal}
                setIsCreateSubTask={setIsCreateSubTask}
                refreshSubTask={refreshSubTask} />

            <ConfirmModal
                modal={modal}
                toggle={() => toggleModal()}
                submitHandler={HandleDeleteTask}
                isLoading={isLoadingDelete}
            />
        </>
    );
}

export default OfficeTaskManagement;